/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Team_Share_Remove_Member_AriaInputs */



/**
* | output |
* | --- |
* | "Remove {email}" |
*
* @param {Team_Share_Remove_Member_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_remove_member_aria = /** @type {((inputs: Team_Share_Remove_Member_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Remove_Member_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
	return /** @type {LocalizedString} */ (`Remove ${i?.email}`)
});